/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'extension.charts.aggregateData': 'Agréger les données',
  'extension.charts.aggregateDataDescription':
    'Combinez les valeurs en un point de données unique lorsque plusieurs lignes ont la même valeur.',
  'extension.charts.category': 'Catégorie',
  'extension.charts.customizeTab': 'Personnaliser',
  'extension.charts.dataMissing.details': 'Le tableau source de ce graphique est introuvable sur la page.',
  'extension.charts.dataMissing.title': 'Aucune donnée à afficher',
  'extension.charts.dataTab': 'Données',
  'extension.charts.defaultColumnName': 'Colonne {0}',
  'extension.charts.defaultTitle': 'Graphique sans titre',
  'extension.charts.defaultYLabel': 'Axe sans titre',
  'extension.charts.extensionTitle': 'Graphique',
  'extension.charts.height': 'Hauteur de la zone de traçage',
  'extension.charts.height.large': 'Plus grande',
  'extension.charts.height.medium': 'Par défaut',
  'extension.charts.height.small': 'Plus petite',
  'extension.charts.horizontal.orientation.label': 'Horizontale',
  'extension.charts.insert.tooltip': 'Insérer un graphique',
  'extension.charts.legend': 'Légende',
  'extension.charts.legend.auto': 'Automatique',
  'extension.charts.legend.bottom': 'En bas',
  'extension.charts.legend.left': 'À gauche',
  'extension.charts.legend.position': 'Position de la légende',
  'extension.charts.legend.right': 'À droite',
  'extension.charts.legend.show': 'Afficher la légende',
  'extension.charts.legend.top': 'En haut',
  'extension.charts.options.label': 'Options du graphique',
  'extension.charts.options.tooltip': 'Modifier les options du graphique',
  'extension.charts.orientation.label': 'Orientation',
  'extension.charts.seriesNames': 'Séries de données',
  'extension.charts.showPoints': 'Afficher les points de données',
  'extension.charts.smoothLines': 'Courbe lissée',
  'extension.charts.style': 'Style',
  'extension.charts.title': 'Titre',
  'extension.charts.type.bar': 'À barres',
  'extension.charts.type.fieldDescription': 'Type de graphique',
  'extension.charts.type.line': 'En courbes',
  'extension.charts.type.pie': 'En secteurs',
  'extension.charts.userTitle': 'Titre',
  'extension.charts.vertical.orientation.label': 'Verticale',
  'extension.charts.xAxis': 'Axe X',
  'extension.charts.xLabel': "Étiquette de l'axe X",
  'extension.charts.yLabel': "Étiquette de l'axe Y",
};
